import React, { useState, useEffect } from 'react'
import { useOrderStore } from 'src/hooks/order';
import AuthConfig from "@system/config/auth";
import Order from "@system/config/order";
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { Tooltip } from 'src/component/Tooltip';
import AuthRepository from 'src/repository/AuthRepository';
import System from 'src/helper/system';
import AlertContentWithFlag from 'src/pages/Checkout/AlertContentWithFlag';
import { __remove, __set } from 'src/store/axios_indicator';

const OrderHistoryEmailPopup = (props) => {
    console.log(props.data.singleOrder);
    const [__check] = useAxiosIndicatorCheck();
    const { SetStatus, data } = props;
    const singleOrder = data.singleOrder
    const singleProduct = data.singleProduct

    const defaultSubject = 'In regard to PO# ' + singleOrder.purchaseOrderNumber + ' - ' + singleProduct.manufacturerPartNumber + ' for Account# ' + AuthConfig.getAccountNumber()

    const [CC, setCC] = useState('')
    const [CCError, setCCError] = useState('')
    const [subject, setSubject] = useState(defaultSubject)
    const [emailError, setEmailError] = useState({ isError: false, isSuccess: false })
    const [message, setMessage] = useState('')
    const [messageError, setMessageError] = useState('')
    const [{ }, { send_order_po_item_email }, { }] = useOrderStore();

    const fromEmail = AuthConfig.getUserName()
    const emailRegex = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*,{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/

    const OnSend = async () => {
        let error = false
        if (CC.trim() !== '' && !CC.match(emailRegex)) {
            setCCError("Please enter a valid Email address.");
            error = true
        }
        if (message.trim().length > 255) {
            setMessageError('Maximum 255 characters allowed')
            error = true
        }

        if (!error && singleOrder && singleProduct) {
            __set('ORDER_LINE_ITEM_EMAIL_API_CALL')
            let res = await send_order_po_item_email({
                lineItemNumber: singleOrder?.lineItemNumber,
                purchaseOrderNumber: singleOrder?.purchaseOrderNumber,
                orderNumber: singleOrder?.orderNumber ?  singleOrder?.orderNumber  : singleOrder?.webOrderNumber,
                message: message,
                zetenr: singleOrder?.zetenr
            });

            __remove('ORDER_LINE_ITEM_EMAIL_API_CALL')
            if (res && res?.isSuccessFull) {
                setEmailError({ isError: false, isSuccess: true });
            }
            else {
                setEmailError({ isError: true, isSuccess: false })
            }
        }
    }

    const onCCChange = (value) => {
        if (value && value.trim() !== '' && !value.match(emailRegex)) {
            setCCError("Please enter a valid Email address.");
        } else {
            setCCError('')
        }
        setCC(value)
    }

    const onMessageChange = (value) => {
        if (value && value.trim().length > 255) {
            setMessageError('Maximum 255 characters allowed')
        } else {
            setMessageError('')
        }
        setMessage(value)
    }
    return (
        <>
            <div className="avnet-modal modal-700">
                <div className="avnet-modal-inner">
                    {/* Modal Header */}
                    <button type="button" className="close py-3" data-dismiss="modal" onClick={(() => SetStatus(false))}>×</button>
                    <div className="modal-header justify-content-center mt-0">
                        <h3 className="modal-title m-auto">{`${emailError.isSuccess ? ' Message was Successfully Sent' : ' Line Item Message'}`}</h3>
                    </div>

                    {/* Modal body */}
                    <div className="modal-body py-0">
                        <div className="clearfix" />
                        {emailError.isError &&
                            <AlertContentWithFlag message={'Email failed to send. Please try again.'} type="danger" isDisplay={false} isDisplayIcon={true} />
                        }
                        <div className='row'>
                            <div className='col-md-10'>
                            </div>
                            <div className='col-md-2'>

                            </div>
                            <div className='col-md-6'>
                                <p className='mb-3 font-13 font-arial'><strong> ORDER INFORMATION</strong></p>
                                {singleOrder &&
                                    <div className='font-13 font-arial'>
                                        <div><b>Order Date: </b>
                                            {singleOrder.finalOrderDate}
                                        </div>
                                        <div><b>PO Number: </b>{singleOrder?.purchaseOrderNumber.trim() !== '' ? singleOrder.purchaseOrderNumber : '-'}
                                        </div>
                                        <div><b>Order Status: </b>{singleOrder?.orderStatus}</div>

                                        <div><b>Web Number: </b> {singleOrder?.webOrderNumber}</div>

                                        <div><b>Order Number: </b> {singleOrder?.sapOrderNumber} </div>
                                        <div><b>Line item Number: </b>{singleOrder?.lineItemNumber}</div>
                                    </div>
                                }
                            </div>
                            <div className='col-md-6'>
                                <p className='mb-3 font-13 font-arial'><strong>PART INFORMATION</strong></p>

                                {
                                    singleProduct &&
                                    <div className='font-13 font-arial'>
                                        <div><b>Manufacturer: </b> {singleProduct.manufacturerName ? singleProduct.manufacturerName : '-'}</div>
                                        <div><b>Manuf. part Number: </b> {singleProduct.manufacturerPartNumber ? singleProduct.manufacturerPartNumber : '-'}</div>
                                        <div><b>Cust. part Number: </b> {singleProduct.customerPartNumber ? singleProduct.customerPartNumber : '-'}</div>
                                        <div><b>Ordered Quantity: </b> {singleProduct?.totalQuantity ? singleProduct?.totalQuantity : '-'}</div>
                                        <div><b>Requested Quantity: </b> {singleProduct.requestedQuantity ? singleProduct.requestedQuantity : '-'}</div>
                                        <div><b>Requested Date: </b> {singleProduct.finalRequestedDate ? singleProduct.finalRequestedDate : '-'}</div>
                                    </div>
                                }
                            </div>
                        </div>
                       

                        <div>
                            <div className="form-group mt-4">
                                <div className='bg-grey2 p-2'>
                                    <label htmlFor="Subject"><b>Subject:</b> {subject}</label>
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="Message"><b>{emailError.isSuccess ? `From ${fromEmail} ` : 'Message*'}</b></label>
                                {emailError.isSuccess && message &&
                                    <p className="text-wrap text-break w-100">{message}</p>
                                }
                                {!emailError.isSuccess &&
                                    <> <textarea name="name" rows="8" cols="60" className="avnet-textBox form-control form-control-sm"
                                        placeholder="Type your message ..."
                                        onChange={(e) => onMessageChange(e.target.value)} value={message}></textarea>
                                        <p className='pull-right d-block mt-2 w-100 text-end text-black-stone'><i>Characters remaining {255 - message.trim().length > 0 ? 255 - message.trim().length : 0}/255</i></p>
                                        <p className="error">{messageError.trim().length > 0 && messageError} </p>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer justify-content-center mt-5 d-flex">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary btn-sm w145" data-dismiss="modal" onClick={() => {
                                SetStatus(false)
                            }}>
                                CLOSE
                            </button>
                            {__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status &&

                                <button type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                                    disabled={true}
                                    onClick={(() => OnSend())}>
                                    <i className="fa fa-spinner fa-spin" />
                                </button>
                            }

                            {!__check(['ORDER_LINE_ITEM_EMAIL_API_CALL']).status && !emailError.isSuccess &&

                                <button type="button" className="bs5 btn btn-primary btn-sm w145" data-dismiss="modal"
                                    disabled={!message}
                                    onClick={(() => OnSend())}>
                                    SEND
                                </button>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrderHistoryEmailPopup